module.exports = __webpack_public_path__ + "img/KK0041C-PX.094361f3.jpg";